export const timezones = [
    { label: 'America/Adak', value: 'America/Adak' },
    { label: 'America/Aleutian', value: 'US/Aleutian' },
    { label: 'America/Anchorage', value: 'America/Anchorage' },
    { label: 'America/Argentina/Buenos Aires', value: 'America/Argentina/Buenos_Aires' },
    { label: 'America/Arizona', value: 'US/Arizona' },
    { label: 'America/Chicago', value: 'America/Chicago' },
    { label: 'America/Denver', value: 'America/Denver' },
    { label: 'America/Godthab', value: 'America/Godthab' },
    { label: 'America/Los Angeles', value: 'America/Los_Angeles' },
    { label: 'America/New York', value: 'America/New_York' },
    { label: 'America/Samoa', value: 'US/Samoa' },
    { label: 'Asia/Anadyr', value: 'Asia/Anadyr' },
    { label: 'Asia/China Standard Time (CST)', value: 'Asia/Macau' },
    { label: 'Asia/Dhaka', value: 'Asia/Dhaka' },
    { label: 'Asia/Dubai', value: 'Asia/Dubai' },
    { label: 'Asia/Jakarta', value: 'Asia/Jakarta' },
    { label: 'Asia/Japan Standard Time (JST)', value: 'Japan' },
    { label: 'Asia/Kathmandu', value: 'Asia/Kathmandu' },
    { label: 'Asia/Kolkata', value: 'Asia/Kolkata' },
    { label: 'Asia/Tashkent', value: 'Asia/Tashkent' },
    { label: 'Asia/Tehran', value: 'Asia/Tehran' },
    { label: 'Asia/Yangon', value: 'Asia/Yangon' },
    { label: 'Atlantic/Cape Verde', value: 'Atlantic/Cape_Verde' },
    { label: 'Australia/Adelaide', value: 'Australia/Adelaide' },
    { label: 'Australia/Eucla', value: 'Australia/Eucla' },
    { label: 'Australia/Lord Howe', value: 'Australia/Lord_Howe' },
    { label: 'Australia/Queensland', value: 'Australia/Queensland' },
    { label: 'Australia/Sydney', value: 'Australia/Sydney' },
    { label: 'Canada/Newfoundland', value: 'Canada/Newfoundland' },
    { label: 'Canada/Saskatchewan', value: 'Canada/Saskatchewan' },
    { label: 'Coordinated Universal Time (UTC)', value: 'UTC' },
    { label: 'Europe/Brussels', value: 'Europe/Brussels' },
    { label: 'Europe/London', value: 'Europe/London' },
    { label: 'Europe/Moscow', value: 'Europe/Moscow' },
    { label: 'Greenwich Mean Time (GMT)', value: 'GMT' },
    { label: 'Pacific/Chatham', value: 'Pacific/Chatham' },
    { label: 'Pacific/Honolulu', value: 'Pacific/Honolulu' },
    { label: 'Pacific/Kiritimati', value: 'Pacific/Kiritimati' },
    { label: 'Pacific/Kosrae', value: 'Pacific/Kosrae' },
    { label: 'Pacific/Marquesas', value: 'Pacific/Marquesas' },
    { label: 'Pacific/Niue', value: 'Pacific/Niue' },
    { label: 'Pacific/Tongatapu', value: 'Pacific/Tongatapu' },
    { label: 'Pacific/Wake', value: 'Pacific/Wake' }
];
